import React from "react";
import { FiChevronUp, FiChevronDown, FiRefreshCw, FiWind, FiPower } from "react-icons/fi";

const modeLabels = ["Off","Cool", "Heat",  "Dry","Fan", "Auto"];
const fanLabels = [ "Auto","Low", "Med", "High"];

const AcController = ({
  temp = 24,
  fan = 1,
  mode = 1,
  protocol = "UNKNOWN",
  status = false,
  auto = false,
  count = 1,
  onTempChange,
  onModeChange,
  onFanChange,
  onPowerToggle,
  onAutoToggle,
}) => {
  return (
    <div className="flex w-full flex-col items-center rounded-lg border border-gray-200 bg-gray-50 p-4">
      {/* AC Display */}
      <div className="w-full flex flex-col items-center mb-4">
        <div className="flex items-center justify-between w-full mb-2">
          <span className="text-xs text-gray-500">Protocol: {protocol}</span>
          <span className="text-xs text-gray-500">Units: {count}</span>
        </div>
        <div className="flex items-center gap-2 mb-2">
          <button
            className="p-2 bg-gray-100 rounded-full hover:bg-blue-100"
            onClick={() => onTempChange && onTempChange(temp + 1)}
            aria-label="Increase Temp"
          >
            <FiChevronUp className="w-5 h-5 text-blue-600" />
          </button>
          <span className="text-5xl font-bold text-blue-700 select-none">
            {temp}
          </span>
          <button
            className="p-2 bg-gray-100 rounded-full hover:bg-blue-100"
            onClick={() => onTempChange && onTempChange(temp - 1)}
            aria-label="Decrease Temp"
          >
            <FiChevronDown className="w-5 h-5 text-blue-600" />
          </button>
        </div>
        <span className="text-lg text-gray-600 mb-1">°C</span>
      </div>

      {/* Status Row */}
      <div className="flex items-center justify-between w-full mb-3">
        <button
          className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold transition-colors ${
            status ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"
          }`}
          onClick={() => onPowerToggle && onPowerToggle(!status)}
        >
          <FiPower className="w-4 h-4" /> {status ? "On" : "Off"}
        </button>
        <button
          className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold transition-colors ${
            auto ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-500"
          }`}
          onClick={() => onAutoToggle && onAutoToggle(!auto)}
        >
          <FiRefreshCw className="w-4 h-4" /> Auto
        </button>
      </div>

      {/* Mode & Fan Controls */}
      <div className="flex flex-col gap-2 w-full">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Mode</span>
          <button
            className="px-3 py-1 bg-gray-100 rounded-full hover:bg-blue-100 text-xs font-semibold text-blue-700"
            onClick={() => onModeChange && onModeChange((mode + 1) % modeLabels.length)}
          >
            {modeLabels[mode] || "Unknown"}
          </button>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Fan</span>
          <div className="flex gap-1">
            {fanLabels.map((label, idx) => (
              <button
                key={label}
                className={`px-2 py-1 rounded-full text-xs font-semibold transition-colors ${
                  fan === idx
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-600 hover:bg-blue-100"
                }`}
                onClick={() => onFanChange && onFanChange(idx)}
              >
                <FiWind className="inline w-3 h-3 mr-1" /> {label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcController;
